import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { route as helpCenterHomeRoute } from "@faire/web-api/routes/support";
import { useStrictLocalization } from "@faire/web/common/localization";
import { BackToDestination } from "./types";
export var useBackToCtaContextMap = function useBackToCtaContextMap() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var backToCtaContextMap = _defineProperty(_defineProperty({}, BackToDestination.FAIRE, {
    label: strictLocalize({
      id: "FRWfB+",
      defaultMessage: "Back to Faire.com"
    }),
    linkTo: "/"
  }), BackToDestination.HELP_CENTER, {
    label: strictLocalize({
      id: "LbI9ID",
      defaultMessage: "Back to Help Center"
    }),
    linkTo: helpCenterHomeRoute
  });
  return {
    backToCtaContextMap: backToCtaContextMap
  };
};